import React, { useState, useEffect } from 'react';
import './main.css';

import Homepage from '../homepage/Homepage';
import Navbar from '../../components/navbar/Navbar';
import Footer from '../../components/footer/Footer';

import { Routes, Route } from 'react-router-dom';
import HeroSectionCoding from '../../components/typingCode/heroSectionCoding/HeroSectionCoding';

import BlogList from "../blog/BlogList";
import BlogPost from "../blog/BlogPost";



const HeroSectionCodingContainer = () => {
  return (
    <div className="full-page-component">
      <HeroSectionCoding />
      <div className="scroll-spacer" />
    </div>
  );
};
const Main = () => {
  const [scrolling, setScrolling] = useState(false);

  // Scroll event listener to toggle navbar visibility based on scroll position
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) { // Change '200' to any desired scroll threshold
        setScrolling(true); // Navbar appears when scrolled more than 200px
      } else {
        setScrolling(false); // Navbar is hidden if scrolled above 200px
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll); // Cleanup on component unmount
    };
  }, [scrolling]);

  return (
    <div className='mainPageContainer'>
      {/* Display HeroSectionCodingContainer initially (Defined on top) */}
      <HeroSectionCodingContainer />

      {/* Render Navbar, Routes, and Footer only after scrolling */}
      {scrolling && (
        <div>
          <Navbar />
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
          </Routes>
          <Footer />
        </div>
      )}
    </div>
  );
};

export default Main;